import { render } from "./Animatable.vue?vue&type=template&id=fa79858a"
import script from "./Animatable.vue?vue&type=script&lang=js"
export * from "./Animatable.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__